import { Link } from '../../../../../../../Resource/Types';
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import Loader from '../../../../../../Loader';
import ImageWrapper from './ImageWrapper';
import { UploadImageStore } from '../UploadImageStore';
import ErrorMessage from './ErrorMessage';
import UploadImage from './UploadImage';

interface Props {
  store: UploadImageStore;
  uploadLink: Link;
  previewUrl: Maybe<Link>;
  setPreviewUrl: (url: Maybe<Link>) => void;
}

function UploadState({ store, uploadLink, setPreviewUrl, previewUrl }: Props) {
  switch (store.state.kind) {
    case 'loading':
      return (
        <ImageWrapper>
          <Loader />
        </ImageWrapper>
      );
    case 'delete':
    case 'ready':
    case 'error':
      return (
        <>
          <UploadImage
            store={store}
            uploadLink={uploadLink}
            previewUrl={previewUrl}
            setPreviewUrl={setPreviewUrl}
          />
          <ErrorMessage error={store.state.message} />
        </>
      );
  }
}

export default observer(UploadState);
